import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export default function loginModel() {
  const fetchGetAvailableLogin = reactive({
    api: apiEndpoint.bcrm_platform + "/account/GetAvailableLoginMethod",
    method: "GET",
    payload: {
      brand_ref: null,
    },
  });

  const fetchLoginOAuth = reactive({
    api: apiEndpoint.bcrm_platform + "/account/LoginOauth",
    method: "GET",
    payload: {
      brand_ref: null,
      provider_ref: null,
    },
  });

  const fetchLogout = reactive({
    api: apiEndpoint.bcrm_platform + "/account/Logout",
    method: "POST",
    payload: {
      access_token: null,
    },
  });

  const fetchLogin = reactive({
    api: apiEndpoint.bcrm_platform + "/account/Login",
    method: "POST",
    payload: {
      brand_ref: null,
      provider_ref: "",
      username: "",
      password: "",
    },
  });

  const fetchProviderInfo = reactive({
    api: apiEndpoint.bcrm_platform + "/account/GetProvider",
    method: "POST",
    payload: {
      provider_ref: null,
    },
  });

  const fetchBrandList = reactive({
    api: apiEndpoint.bcrm_platform + "/account/GetBrandList",
    method: "POST",
    payload: {
      access_token: null,
    },
  });

  const fetchSubmitBrand = reactive({
    api: apiEndpoint.bcrm_platform + "/account/submitBrand",
    method: "POST",
    payload: {
      access_token: null,
      refresh_token: null,
      brand_ref: null,
      state: "",
      payload: "",
    },
  });

  const fetchRefreshToken = reactive({
    api: apiEndpoint.bcrm_platform + "/account/RefreshToken",
    method: "POST",
    payload: {
      access_token: null,
      refresh_token: null,
    },
  });

  const GetUserChangePasswordFirstTime = reactive({
    api: apiEndpoint.bcrm_platform + "/account/GetUserChangePasswordFirstTime",
    method: "POST",
    payload: {
      Username: "",
      Provider_Ref: "",
    },
  });

  const fetchResetPassword = reactive({
    api: apiEndpoint.bcrm_platform + "/account/ResetPassword",
    method: "POST",
    payload: {
      Access_Token: "",
      Provider_Ref: "",
      Username: "",
      New_Password: "",
      Old_Password: "",
    },
  });

  const fetchRequestOTP = reactive({
    api: apiEndpoint.bcrm_platform + "/account/requestotp",
    method: "POST",
    payload: {
      brand_ref: "BL6ZLW8PXBXA",
      provider_Ref: "PVb3vMVHFFy7hC",
      //app_Id: "A5WP9YAEW9C9",
      mobile_no: "892131551",
      country_code: "66",
      verify_user: true,
    },
  });

  const fetchResendRequestOTP = reactive({
    api: apiEndpoint.bcrm_platform + "/account/resendotp",
    method: "POST",
    payload: {
      brand_ref: "BL6ZLW8PXBXA",
      provider_ref: "PVb3vMVHFFy7hC",
      mobile_no: "892131551",
      country_code: "66",
      tx_reference: "5ec23177-ead7-46c6-a6fe-68f794df6b5e",
      verify_user: true,
    },
  });

  return {
    fetchGetAvailableLogin,
    fetchLoginOAuth,
    fetchLogout,
    fetchLogin,
    fetchProviderInfo,
    fetchBrandList,
    fetchSubmitBrand,
    fetchRefreshToken,
    GetUserChangePasswordFirstTime,
    fetchResetPassword,
    fetchRequestOTP,
    fetchResendRequestOTP,
  };
}
